import { LinearProgress, Typography } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import React from "react";
import styles from "./OverviewGoalProgress.module.scss";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";

export interface IOverviewProgress {
  util: string;
  unit: string;
  currentValue: number;
  goalValue: number;
  onReadMore?: (meter: string) => void;
}

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    borderRadius: "0px 20px 20px 0px",
    position: "relative",
    padding: "2px 0px",
  },
}));
const BorderLinearProgress = withStyles(() => ({
  root: {
    height: 24,
    borderRadius: "0px 20px 20px 0px",
    boxShadow: "0px 0px 0 0.5px #8CC3C9",
  },
  colorPrimary: { backgroundColor: "transparent" },
  bar: {
    borderRadius: "0px 20px 20px 0px",
    backgroundColor: "#8CC3C9",
  },
}))(LinearProgress);

export const OverviewGoalProgress = ({
  util,
  unit,
  currentValue,
  goalValue,
  onReadMore,
}: IOverviewProgress) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const progress = (currentValue / goalValue) * 100;
  return (
    <div
      onClick={() => onReadMore && onReadMore(util)}
      className={styles.container}
    >
      <div className={styles.row}>
        <Typography variant="subtitle2">{util}</Typography>
      </div>
      <div className={styles.row}>
        <div className={classes.root}>
          <Typography variant="subtitle1" className={styles.valueText}>
            {`${currentValue} / ${goalValue} ${unit}`}
          </Typography>
          <BorderLinearProgress
            variant="determinate"
            color={"primary"}
            value={progress}
          />
        </div>
      </div>
      <Typography variant="subtitle1" className={styles.linkText}>
        {t("Read more")}
      </Typography>
    </div>
  );
};
